import { Icon } from '@mui/material';
import { Flex, QRCode } from 'antd';
import { useEffect, useState } from 'react';
import { getStudentCode } from '../../../shared/api/edificeRequest';

import '../../css/StudentAds.css';

const StudentAds = () => {
  const [code, setCode] = useState('');
  const [showCode, setShowCode] = useState(false);

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
  const [show, setShow] = useState(false);

  useEffect(() => {
    const loadStudentCode = async () => {
      const res = await getStudentCode();
      if (res.code) setCode(res.code);
      setShowCode(true);
    };
    setTimeout(() => {
      loadStudentCode();
    }, 2000);
  }, []);

  if (!showCode) return <></>;

  if (!show)
    return (
      <div
        style={{
          position: 'fixed',
          bottom: 30,
          left: 30,
          padding: 20,
          borderRadius: 8,
          backgroundColor: '#3E276F',
        }}
        onClick={() =>
          isMobile ? window.open('https://nabook.onelink.me/d3QQ/3ptadrfm?af_force_deeplink=true', '_blank') : setShow(true)
        }>
        <Flex gap={18} style={{ flexDirection: 'column' }}>
          {isMobile && (
            <div
              className="serie-title"
              style={{
                fontSize: 16,
                color: 'white',
              }}>
              L'APP MOBILE NABOOK
            </div>
          )}
          <Flex style={{ flexDirection: 'row' }} gap={18}>
            <Flex
              style={{
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <QRCode size={90} value="https://nabook.onelink.me/d3QQ/3ptadrfm?af_force_deeplink=true" bgColor={'white'} />
            </Flex>
            <Flex
              style={{
                flexDirection: 'column',
                justifyContent: 'center',
                gap: 4,
              }}>
              <div
                className="title"
                style={{
                  fontSize: 12,
                  color: 'white',
                }}>
                Code élève
              </div>
              {code && code !== '' ? (
                <div
                  className="serie-title"
                  style={{
                    color: '#FFCE02',
                    fontSize: 22,
                    textAlign: 'center',
                    width: '100%',
                  }}>
                  {code}
                </div>
              ) : (
                <div
                  className="resume"
                  style={{
                    textAlign: 'center',
                    width: '100%',
                  }}>
                  Aucun code élève attribué
                </div>
              )}
            </Flex>
          </Flex>
        </Flex>
      </div>
    );

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 30,
        right: 30,
      }}>
      <div
        style={{
          backgroundColor: '#FECF03',
          borderRadius: 8,
          maxWidth: 700,
          paddingBottom: 8,
          paddingRight: 8,
        }}>
        <div
          style={{
            backgroundColor: '#3E276F',
            borderRadius: 8,
            maxWidth: 700,
            padding: 20,
            marginTop: -8,
            marginLeft: -8,
          }}>
          <Flex style={{ alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer' }} onClick={() => setShow(false)}>
            <Icon sx={{ fontSize: 24, color: 'white' }}>{'close'}</Icon>
          </Flex>
          <Flex gap={18} className="student-ads-flex">
            <Flex
              style={{
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <QRCode value="https://nabook.onelink.me/d3QQ/3ptadrfm?af_force_deeplink=true" bgColor={'white'} />
            </Flex>
            <Flex style={{ padding: 8 }} vertical>
              <div
                className="serie-title"
                style={{
                  fontSize: 24,
                  color: 'white',
                }}>
                AVEC L'APPLI MOBILE NABOOK
              </div>
              <ul>
                <li
                  className="resume"
                  style={{
                    fontSize: 16,
                  }}>
                  Lisez un épisode gratuitement par jour
                </li>
                <li
                  className="resume"
                  style={{
                    fontSize: 16,
                  }}>
                  Accédez à +300 titres
                </li>
                <li
                  className="resume"
                  style={{
                    fontSize: 16,
                  }}>
                  Profitez d'un meilleur confort de lecture
                </li>
              </ul>
              <Flex
                gap={14}
                style={{
                  backgroundColor: '#2B1A59',
                  borderRadius: 8,
                  padding: 12,
                  marginTop: 12,
                }}
                vertical>
                <div>Code élève</div>
                <div
                  className="title"
                  style={{
                    color: '#FFCE02',
                    fontSize: 22,
                    textAlign: 'center',
                    width: '100%',
                  }}>
                  {code}
                </div>
                <div
                  className="poppins-italic"
                  style={{
                    fontSize: 14,
                    textAlign: 'center',
                    marginBottom: 8,
                  }}>
                  💡 Utilisez votre code élève pour retrouver les lectures distribuées par votre enseignant.
                </div>
              </Flex>
            </Flex>
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default StudentAds;
